import type { EdgeTone } from './types';

// Tone → Tailwind text-color class. Stroke/marker/label colour all inherit
// via currentColor from the wrapping <g className={...}>.
export function edgeToneClass(t: EdgeTone) {
  switch (t) {
    case 'auto-enrolled':
      return 'text-emerald-500';
    case 'manually-enrolled':
      // Rose-400 — further desaturated from the original rose-600. On
      // dark backgrounds the deeper rose read as near-black and made
      // the "Manually enrolled (X%)" pill labels hard to scan. A
      // lighter rose keeps the "bottleneck" association while staying
      // readable next to the other edge colours.
      return 'text-rose-400';
    case 'escalated':
      return 'text-amber-500';
    case 'resolved':
      // Cyan — visually tied to the escalation workflow (same warm/cool
      // family as amber's complement) without duplicating its meaning.
      return 'text-sky-400';
    default:
      return 'text-border';
  }
}
